import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { theme } from "../theme.js";
import LoadingOverlay from "../components/LoadingOverlay.jsx";
import Section from "../components/base/Section.jsx";
import Input from "../components/base/Input.jsx";
import Form from "../components/base/Form.jsx";
import ConnexionCard from "../components/ConnexionCard.jsx";
import Helper from "../components/base/Helper.jsx";

const API_URL = process.env.REACT_APP_API_URL;

export default function Login() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Suppress Supabase session synchronization errors globally
  useEffect(() => {
    const handleError = (event) => {
      if (event.message && (
        event.message.includes("Session synchronization") ||
        event.message.includes("Lock was stolen") ||
        event.message.includes("multiple tabs")
      )) {
        event.preventDefault();
        console.warn("Suppressed Supabase session error:", event.message);
      }
    };

    window.addEventListener("error", handleError);
    window.addEventListener("unhandledrejection", (event) => {
      if (event.reason && event.reason.message && (
        event.reason.message.includes("Session synchronization") ||
        event.reason.message.includes("Lock was stolen") ||
        event.reason.message.includes("multiple tabs")
      )) {
        event.preventDefault();
        console.warn("Suppressed Supabase session rejection:", event.reason.message);
      }
    });

    // Clear stale Supabase locks on component mount
    try {
      const keysToCheck = [
        'sb-mdidlwnnrgzwjwgydotv-auth-token',
        'sb-mdidlwnnrgzwjwgydotv-session',
        'supabase.session',
        'supabase.access_token'
      ];
      keysToCheck.forEach(key => {
        try {
          localStorage.removeItem(key);
        } catch (e) {
          console.debug(`Could not remove ${key}:`, e);
        }
      });
    } catch (e) {
      console.debug("Error clearing Supabase session on mount:", e);
    }

    return () => {
      window.removeEventListener("error", handleError);
    };
  }, []);

const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    
    try {
        const res = await fetch(`${API_URL}/auth/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify(formData),
        });

        if (res.ok) {
        const data = await res.json();
        console.log("Login successful:", data);
        localStorage.setItem("participant", JSON.stringify(data.participant));
        localStorage.setItem("user", JSON.stringify(data.user));
        console.log("User and participant info saved to localStorage." + JSON.stringify(data.user) + " / " + JSON.stringify(data.participant));
        
        // Rediriger vers la page de connexion ou home
        navigate("/user", { replace: true });
        } else {
        const errorData = await res.json();
        setError(errorData.detail || "Erreur de connexion");
        }
    } catch (err) {
        setError("Erreur de connexion au serveur");
    } finally {
        setLoading(false);
    }
};


  return (
    <>
      <ConnexionCard  brand="BIBbib" title="Welcome back" subtitle="Sign in to continue">
        <Section title={null}>
          <Form onSubmit={handleSubmit} >
            <Input label="Email" name="email" value={formData.email} setFormData={setFormData} type="email" />
            <Input label="Password" name="password" value={formData.password} setFormData={setFormData} type="password" />
            {error && <p style={styles.error}>{error}</p>}            
          </Form>
        </Section>

        <Helper title="Pas encore de compte ?" cta="S'inscrire" to="/signup" />
      </ConnexionCard>
      <LoadingOverlay isVisible={loading} message="Connexion en cours..." />
    </>
  );
}

const styles = {
  page: {
    minHeight: "100vh",
    display: "grid",
    placeItems: "center",
    background: "linear-gradient(135deg, #111 0%, #222 100%)",
    padding: theme.spacing.lg,
  },
  card: {
    width: "100%",
    maxWidth: 420,
    background: theme.colors.white,
    borderRadius: theme.radius.xl,
    boxShadow: theme.shadows.xl,
    padding: theme.spacing.lg,
  },
  brand: {
    fontWeight: theme.fonts.weight.extrabold,
    letterSpacing: 0.5,
    color: theme.colors.text,
    fontSize: theme.fonts.size.sm,
    marginBottom: theme.spacing.xs,
  },
  title: {
    fontSize: theme.fonts.size.xl,
    margin: 0,
    color: theme.colors.text,
  },
  subtitle: {
    margin: `${theme.spacing.xs} 0 ${theme.spacing.md} 0`,
    color: theme.colors.textLight,
    fontSize: theme.fonts.size.sm,
  },
  socials: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: theme.spacing.md,
    marginBottom: theme.spacing.md,
  },
  divider: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: `${theme.spacing.xs} 0 ${theme.spacing.md} 0`,
    color: theme.colors.textLight,
    fontSize: theme.fonts.size.xs,
  },
  error: {
    color: theme.colors.error,
    fontSize: theme.fonts.size.xs,
  },
};
